/**
 * design-skins — 디자인 스킨 레지스트리.
 *
 * 【역할】
 * - 5종 스킨(classic/soft/vivid/mono/neo) 을 키로 조회 가능한 Record 로 노출.
 * - themeStore 의 skin 축, useTheme 의 token 합산, AppHeader 설정 UI 가 공통으로 사용.
 *
 * 【스킨 추가 절차】 docs/DESIGN_SKINS.md 참조.
 *   1. design-skins/xxx.ts 정의
 *   2. 이 파일의 THEME_SKINS 에 등록
 *   3. types.ts 의 ThemeSkinKey union 에 키 추가
 *   4. styles/skins.css 에 body[data-skin="xxx"] overlay 작성
 *   5. i18n 라벨 (LBL_SKIN_XXX) 등록 (선택)
 */
import type { SkinDef, ThemeSkinKey } from './types'
import { classicSkin } from './classic'
import { softSkin } from './soft'
import { vividSkin } from './vivid'
import { monoSkin } from './mono'
import { neoSkin } from './neo'

export const THEME_SKINS: Record<ThemeSkinKey, SkinDef> = {
  classic: classicSkin,
  soft: softSkin,
  vivid: vividSkin,
  mono: monoSkin,
  neo: neoSkin
}

/** 설정 UI 에서 표시 순서 보장용 */
export const SKIN_ORDER: ThemeSkinKey[] = ['classic', 'soft', 'vivid', 'mono', 'neo']

export type { SkinDef, ThemeSkinKey, SkinSwatch } from './types'
export { classicSkin, softSkin, vividSkin, monoSkin, neoSkin }
